import axios from "axios";
import { handleResponse } from "./HelperService";

const getCountryAll = (params, onSuccess, onError) => {
  const response = axios.get("v1/county", { params });
  return handleResponse(response, onSuccess, onError);
};

const getProvince = (id, onSuccess, onError) => {
  const response = axios.get(`v1/county/${id}`);
  return handleResponse(response, onSuccess, onError);
};

const rehitInvoice = (so_id, onSuccess, onError) => {
  const response = axios.get(`v1/invoice-rehit/${so_id}`);
  return handleResponse(response, onSuccess, onError);
};

const rehitDP = (so_id, onSuccess, onError) => {
  const response = axios.get(`v1/dp-rehit/${so_id}`);
  return handleResponse(response, onSuccess, onError);
};

const createCustomer = (payload, onSuccess, onError) => {
  const response = axios.post(`v1/customer`, payload);
  return handleResponse(response, onSuccess, onError);
};
const getCustomerAll = (params, onSuccess, onError) => {
  const response = axios.get("v1/customer?showMR=1", { params });
  return handleResponse(response, onSuccess, onError);
};

const getSeries = (params, onSuccess, onError) => {
  const response = axios.get("v1/series", { params });
  return handleResponse(response, onSuccess, onError);
};
const getSeriesCustomer = (params, onSuccess, onError) => {
  const response = axios.get("v1/series", { params });
  return handleResponse(response, onSuccess, onError);
};
const getDebitorAccount = (params, onSuccess, onError) => {
  const response = axios.get("v1/glaccount", { params });
  return handleResponse(response, onSuccess, onError);
};
const getPPN = (params, onSuccess, onError) => {
  const response = axios.get("v1/ppn", { params });
  return handleResponse(response, onSuccess, onError);
};
const createAddress = (payload, cardCode, onSuccess, onError) => {
  const response = axios.post(`v1/customer/${cardCode}/address`, payload);
  return handleResponse(response, onSuccess, onError);
};
const getSO = (params, onSuccess, onError) => {
  const response = axios.get(`v1/salesorder`, { params });
  return handleResponse(response, onSuccess, onError);
};
const getSoPending = (params, onSuccess, onError) => {
  const response = axios.get(`v1/salesorder?showPending=1`, { params });
  return handleResponse(response, onSuccess, onError);
};
const getSODelivery = (params, onSuccess, onError) => {
  const response = axios.get(`v1/sodetaildeliv`, { params });
  return handleResponse(response, onSuccess, onError);
};
const getListProduk = (params, onSuccess, onError) => {
  const response = axios.get(`v1/product`, { params });
  return handleResponse(response, onSuccess, onError);
};
const getPPH = (params, onSuccess, onError) => {
  const response = axios.get(`v1/pph`, { params });
  return handleResponse(response, onSuccess, onError);
};
const getCustomerPph = (params, onSuccess, onError) => {
  const response = axios.get(`v1/customer-pph`, { params });
  return handleResponse(response, onSuccess, onError);
};
const getPromo = (params, onSuccess, onError) => {
  const response = axios.get(`v1/campaign`, { params });
  return handleResponse(response, onSuccess, onError);
};
const createSOHeader = (payload, onSuccess, onError) => {
  const response = axios.post(`v1/salesorder`, payload);
  return handleResponse(response, onSuccess, onError);
};
const syncCustomer = (cardCode, onSuccess, onError) => {
  const response = axios.get(`v1/customer/sap-sync/${cardCode}`, {});
  return handleResponse(response, onSuccess, onError);
};
const deleteCustomer = (cardCode, onSuccess, onError) => {
  const response = axios.delete(`v1/customer/${cardCode}`, {});
  return handleResponse(response, onSuccess, onError);
}
const getStok = (payload, onSuccess, onError) => {
  const response = axios.post(`v1/cekstok`, payload);
  return handleResponse(response, onSuccess, onError);
};
const applyCampaign = (payload, onSuccess, onError) => {
  const response = axios.post(`v1/campaign`, payload);
  return handleResponse(response, onSuccess, onError);
};
const cancelpromokodeSvc = (id, onSuccess, onError) => {
  const response = axios.get(`v1/salesorder-cancelvoucher/${id}`, {});
  return handleResponse(response, onSuccess, onError);
};
const getOrderType = (params, onSuccess, onError) => {
  const response = axios.get(`v1/ordertype`, { params });
  return handleResponse(response, onSuccess, onError);
};
const getBank = (params, onSuccess, onError) => {
  const response = axios.get(`v1/bank`, { params });
  return handleResponse(response, onSuccess, onError);
};
const createSODetail = (payload, onSuccess, onError) => {
  const response = axios.post(`v1/salesorderdt`, payload);
  return handleResponse(response, onSuccess, onError);
};
const deleteSODetail = (id, onSuccess, onError) => {
  const response = axios.delete(`v1/salesorderdt/${id}`);
  return handleResponse(response, onSuccess, onError);
};
const updatePPN = (id, payload, onSuccess, onError) => {
  const response = axios.put(`v1/salesorderdt/${id}/ppn`, payload);
  return handleResponse(response, onSuccess, onError);
};
const updateSODetail = (id, payload, onSuccess, onError) => {
  const response = axios.put(`v1/salesorderdt/${id}`, payload);
  return handleResponse(response, onSuccess, onError);
};
const getSOHeader = (id, onSuccess, onError) => {
  const response = axios.get(`v1/joinso/${id}`);
  return handleResponse(response, onSuccess, onError);
};

const getAddDocsStatus = (type, so_number, onSuccess, onError) => {
  const response = axios.get(`v1/additional-docs-status/${type}/${so_number}`);
  return handleResponse(response, onSuccess, onError);
};

const sendMail = (payload, onSuccess, onError) => {
  const response = axios.post(`v1/salesorder-mail`, payload);
  return handleResponse(response, onSuccess, onError);
};

const cekPOExist = (id, onSuccess, onError) => {
  const response = axios.get(`v1/purchaseorder?filter=docnumso:${id}`);
  return handleResponse(response, onSuccess, onError);
};
const cekDraft = (id, onSuccess, onError) => {
  const response = axios.post(`v1/salesorder/cardcode/${id}`);
  return handleResponse(response, onSuccess, onError);
};

const verifyPayment = (id, status, onSuccess, onError) => {
  const response = axios.put(
    `v1/salesorder_payment-verificationstatus/${id}/${status}`
  );
  return handleResponse(response, onSuccess, onError);
};

const hitIncomingPayment = (id, onSuccess, onError) => {
  const response = axios.post(`v1/salesorder_payment-hit-incoming-payment/${id}`);
  return handleResponse(response, onSuccess, onError);
};

const getCustomer = (params, showMR = true, onSuccess, onError) => {
  let valMR = showMR ? 1 : 0;
  const response = axios.get(`v1/customer?showMR=${valMR}`, { params });
  return handleResponse(response, onSuccess, onError);
};
const updateDelivery = (id, payload, onSuccess, onError) => {
  const response = axios.put(`v1/salesorderdt/${id}/delivery`, payload);
  return handleResponse(response, onSuccess, onError);
};
const updateCustomer = (kode, payload, onSuccess, onError) => {
  const response = axios.post(`v1/customer-update/${kode}`, payload);
  return handleResponse(response, onSuccess, onError);
};
const updateAddressCustomer = (
  kode,
  address_kode,
  payload,
  onSuccess,
  onError
) => {
  const response = axios.post(
    `v1/customer-update/${kode}/${address_kode}`,
    payload
  );
  return handleResponse(response, onSuccess, onError);
};
const updateSO = (id, payload, onSuccess, onError) => {
  const response = axios.put(`v1/salesorder/${id}`, payload);
  return handleResponse(response, onSuccess, onError);
};
const createPayment = (payload, onSuccess, onError) => {
  const response = axios.post(`v1/salesorder_payment`, payload);
  return handleResponse(response, onSuccess, onError);
};

const createPaymentGateway = (docnumso, payload, onSuccess, onError) => {
  const response = axios.post(`v1/ipg-payment/create/${docnumso}`, payload);
  return handleResponse(response, onSuccess, onError);
};

const cancelPaymentLink = (docnumso, onSuccess, onError) => {
  const response = axios.post(`v1/ipg-payment/cancel/${docnumso}`);
  return handleResponse(response, onSuccess, onError);
};

const updatePayment = (id, payload, onSuccess, onError) => {
  const response = axios.put(`v1/salesorder_payment/${id}`, payload);
  return handleResponse(response, onSuccess, onError);
};
const submitPO = (id, payload, onSuccess, onError) => {
  const response = axios.post(`v1/purchaseorder-import/${id}`, payload);
  return handleResponse(response, onSuccess, onError);
};
const deletePayment = (id, onSuccess, onError) => {
  const response = axios.delete(`v1/salesorder_payment/${id}`);
  return handleResponse(response, onSuccess, onError);
};
const createTax = (payload, onSuccess, onError) => {
  const response = axios.post(`v1/salesorder_tax`, payload);
  return handleResponse(response, onSuccess, onError);
};
const deleteSOHeader = (id, onSuccess, onError) => {
  const response = axios.delete(`v1/salesorder/${id}`);
  return handleResponse(response, onSuccess, onError);
};

const syncSOHeader = (id, onSuccess, onError) => {
  const response = axios.post(`v1/salesorder/sync/${id}`);
  return handleResponse(response, onSuccess, onError);
};

const getPromoDetail = (paketid, item_id, dealer_id, onSuccess, onError) => {
  const response = axios.get(
    `v1/campaign-preorder/${paketid}/${item_id}/${dealer_id}`
  );
  return handleResponse(response, onSuccess, onError);
};

const sendEmailNonIpg = (id, onSuccess, onError) => {
  const response = axios.get(`v1/salesorder-sales-notification/${id}`);
  return handleResponse(response, onSuccess, onError);
};

const getExcludeGudang = (id, onSuccess, onError) => {
  const response = axios.get(`v1/generalcode/${id}`);
  return handleResponse(response, onSuccess, onError);
};

const getTransitWhsCabang = (onSuccess, onError) => {
  const response = axios.get(`v1/generalcode/2`);
  return handleResponse(response, onSuccess, onError);
};

const getDealerNonPKP = (onSuccess, onError) => {
  const response = axios.get(`v1/generalcode/3`);
  return handleResponse(response, onSuccess, onError);
};

const getConfigAll = (params, onSuccess, onError) => {
  const response = axios.get(`v1/configs`, { params });
  return handleResponse(response, onSuccess, onError);
};

export {
  getConfigAll,
  getCountryAll,
  getProvince,
  createCustomer,
  getCustomerAll,
  updateCustomer,
  getSeries,
  getDebitorAccount,
  getPPN,
  createAddress,
  getSO,
  getListProduk,
  getPPH,
  getCustomerPph,
  getPromo,
  createSOHeader,
  getStok,
  applyCampaign,
  getOrderType,
  createSODetail,
  deleteSODetail,
  updatePPN,
  getSOHeader,
  getCustomer,
  updateDelivery,
  updateSODetail,
  updateAddressCustomer,
  updateSO,
  createPayment,
  deletePayment,
  createTax,
  deleteSOHeader,
  updatePayment,
  getSeriesCustomer,
  getSoPending,
  cekDraft,
  getSODelivery,
  cekPOExist,
  submitPO,
  getBank,
  verifyPayment,
  sendMail,
  cancelpromokodeSvc,
  getPromoDetail,
  createPaymentGateway,
  cancelPaymentLink,
  sendEmailNonIpg,
  getExcludeGudang,
  getAddDocsStatus,
  rehitInvoice,
  rehitDP,
  syncCustomer,
  deleteCustomer,
  syncSOHeader,
  getTransitWhsCabang,
  hitIncomingPayment,
  getDealerNonPKP
};
